import { render } from "./BaseImageUpload.vue?vue&type=template&id=4692affe&scoped=true"
import script from "./BaseImageUpload.vue?vue&type=script&lang=js"
export * from "./BaseImageUpload.vue?vue&type=script&lang=js"

import "./BaseImageUpload.vue?vue&type=style&index=0&id=4692affe&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4692affe"]])

export default __exports__